export default __webpack_public_path__ + "static/media/EWG-RatingsPage-Mobile.71460cf8.png";